import React from 'react';
import Warning from 'Common/Components/Warning';
import { Wrapper, ModalWrapper } from 'Common/Components/ConfirmNavigationModal/styled';
import useShortcut from 'Hooks/useShortcut';
import useShortcutScope from 'Hooks/useShortcutScope';
import { StyledMessage, Asterisk } from './styled';

const Message = ({ errorMessage }) => (
  <StyledMessage>{ errorMessage } ( <Asterisk /> )</StyledMessage>
);

const CreationWarning = ({ errorTitle, errorMessage, onClose }) => {
  const scope = useShortcutScope('creation-warning');
  useShortcut('Escape', onClose, { scope });

  return (
    <Wrapper>
      <ModalWrapper>
        <Warning
          title={ errorTitle }
          children={ <Message errorMessage={ errorMessage } /> }
          onClose={ onClose }
        />
      </ModalWrapper>
    </Wrapper>
  );
};

export default CreationWarning;
